import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const RoomCreate = (props) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [rentAmount, setRentAmount] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [pinCodes, setPinCodes] = useState([]);

    const { isAuthenticated, companyId, userId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);


    const clearForm = () => {
        setName("");
        setDescription("");
        setRentAmount("");
    };

    const submitData = async (e) => {
        e.preventDefault();
        if (!name || !rentAmount) {
            setErrorMessage("All fields are required!");
            return;
        }

        const RoomCreateData = {
            CompanyId: companyId,
            Name: name,
            Description: description,
            RentAmount: rentAmount,
            CreatedBy: userId,
            CreatedDate: new Date(),
        };

        postData('RoomApi', RoomCreateData, token)
            .then((response) => {
                console.log('Room Created success:', response);
                setSuccessMessage("Room Created successful!");
                setErrorMessage("");
                clearForm();
                history.push('/RoomIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Room Create error:', error);
                setErrorMessage('Room Create error occurred');
            });
    };

    const phoneNumberPattern = /^\d{10}$/;

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>
                    
                    <div className='w-full mb-2 flex flex-col md:flex-row items-center'>
                        <h6 className='productHead flex-grow linkcolor text-center md:text-left' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>
                        ROOM CREATE
                        </h6>
                        <div className='flex flex-col md:flex-row md:items-center md:ml-4'>
                        <Tooltip title="Back To List">
                            <Link to="/roomindex" className="text-red-500 no-underline font-bold flex items-center">
                                <Button className="text-brown-500 font-bold" style={{color:'darkred'}}>
                                    Back To List <ArrowForwardIosIcon  style={{color:'darkred'}}/>
                                </Button>
                            </Link>
                        </Tooltip>
                        <Tooltip title="SAVE">
                            <Button onClick={submitData} className="text-green-500 font-bold" disabled={isLoading} style={{color:'darkgreen'}}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>
                        </Tooltip>
                        </div>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex flex-col sm:flex-row">
                        <div className="w-full sm:w-1/5 mb-2 sm:mb-0 sm:mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Room Name / No.
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter Room Name/No."
                            />
                        </div>

                        <div className="w-full sm:w-4/5">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Description">
                                Description
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                type="text"
                                placeholder="Enter Description"
                            />
                        </div>
                    </div>

                    <div className="w-full mb-4">
                        <div className="w-1/3 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="contactNumber1">
                                Rent Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={rentAmount}
                                onChange={(e) => setRentAmount(e.target.value)}
                                type="number"
                                placeholder="Enter Rent Amount"
                            />
                        </div>
                    </div>
                </form>
            </div>

        </Fragment>
    );
}

export default RoomCreate;


